import Vector from "../../math/Vector";

export default class Explosion {
    /**
     */
    constructor() {
        /**
         * @constant
         * @type {Vector}
         */
        this.position = new Vector(0, 0);
        /**
         * @type {number}
         */
        this.time = Date.now();
        /**
         * @type {boolean}
         */
        this.active = false;
    }

    /**
     * @param {Vector} position 
     */
    activate(position) {
        this.position.copy(position);
        this.time = Date.now();
        this.active = true;
    }

    deactivate() {
        this.active = false;
    }
}